import { Header } from '../components/Header';
import { Hero } from '../sections/Hero';
import { ManifestoMarquee } from '../sections/ManifestoMarquee';
import { ServiceLayer } from '../sections/ServiceLayer';
import { DarkProduct } from '../sections/DarkProduct';
import { Approach } from '../sections/Approach';
import { Integrations } from '../sections/Integrations';
import { WhoItsFor } from '../sections/WhoItsFor';
import { CtaBanner } from '../sections/CtaBanner';
import { EnquiryForm } from '../sections/EnquiryForm';
import { Footer } from '../sections/Footer';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <ManifestoMarquee />
        <ServiceLayer />
        <DarkProduct />
        <Approach />
        <Integrations />
        <WhoItsFor />
        <CtaBanner />
        <EnquiryForm />
      </main>
      <Footer />
    </>
  );
}
